<script lang="ts">
  import Nav from './Nav.svelte'

  let { data, children } = $props()
</script>

<div class="@submenu-container +medium help-container">
  <Nav tree={data.tree} />

  <div class="content">
    {@render children?.()}
  </div>
</div>

<style lang="postcss">
  .help-container {
    padding-bottom: 0;
  }
  .content {
    max-width: 70ch;
  }
</style>
